import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconBoldLevel: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3304 0.000427246H14.6694C18.0704 0.000427246 19.9904 1.92943 20.0004 5.33043V14.6704C20.0004 18.0704 18.0704 20.0004 14.6694 20.0004H5.3304C1.9294 20.0004 0.000396729 18.0704 0.000396729 14.6704V5.33043C0.000396729 1.92943 1.9294 0.000427246 5.3304 0.000427246ZM10.0494 15.8604C10.4804 15.8604 10.8394 15.5404 10.8794 15.1104V4.92043C10.9194 4.61043 10.7704 4.29943 10.5004 4.13043C10.2194 3.96043 9.8794 3.96043 9.6104 4.13043C9.3394 4.29943 9.1904 4.61043 9.2194 4.92043V15.1104C9.2704 15.5404 9.6294 15.8604 10.0494 15.8604ZM14.6504 15.8604C15.0704 15.8604 15.4294 15.5404 15.4804 15.1104V11.8304C15.5094 11.5094 15.3604 11.2104 15.0894 11.0404C14.8204 10.8704 14.4804 10.8704 14.2004 11.0404C13.9294 11.2104 13.7804 11.5094 13.8204 11.8304V15.1104C13.8604 15.5404 14.2194 15.8604 14.6504 15.8604ZM6.2194 15.1104C6.1794 15.5404 5.8204 15.8604 5.3894 15.8604C4.9594 15.8604 4.5994 15.5404 4.5604 15.1104V8.20043C4.5304 7.88943 4.6794 7.58043 4.9504 7.41043C5.2194 7.24043 5.5604 7.24043 5.8304 7.41043C6.0994 7.58043 6.2504 7.88943 6.2194 8.20043V15.1104Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconBoldLevel;
